module.exports = __webpack_public_path__ + "img/ceau_2kl.c284e7df.jpg";